<lla-range-date-picker
  focusInput="start"
  [value]="data.selectedValue"
  [maxDate]="data.maxDate"
  [minDate]="data.minDate"
  [hideAllPeriods]="data.hideAllPeriods"
  [hiddenPeriods]="data.hiddenPeriods"
  [showMoonLanding]="data.showMoonLanding"
  [enableRangePickerType]="data.enableRangePickerType"
  [rangePickerType]="rangePickerType"
  (valueChanged)="dialogRef.close($event)"
  (canceld)="dialogRef.close()"
  (rangePickerTypeChange)="saveRangePickerType($event)"
></lla-range-date-picker>
